import { categories } from '@/mocks/categories';
import CategoryCard from '@/components/base/CategoryCard';

export default function CategorySection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">探索内容分类</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            八大内容分类，覆盖生活方方面面，总能找到你感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <CategoryCard
              key={cat.slug}
              slug={cat.slug}
              name={cat.name}
              icon={cat.icon}
              description={cat.description}
              color={cat.color}
              imageSeq={cat.imageSeq}
              index={idx}
            />
          ))}
        </div>
      </div>
    </section>
  );
}